import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

export interface EditActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const EditAction: React.FC<EditActionProps> = ({ className, ...buttonProps }) => (
  <button {...buttonProps} type="button" className={className}>
    <FormattedMessage id="actions.edit" />
  </button>
);
